/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Button, Grid } from "@mui/material";
import { Typography, Box } from '@mui/material';

const ServicesSection = ({ darkMode }) => {
  const [activeTab, setActiveTab] = useState("features-tab-1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section
      id="features"
      className="features section py-5"
      style={{ backgroundColor: darkMode ? "#333" : "#f8f9fa", color: darkMode ? "#fff" : "#000" }}
    >


        <Box textAlign="center" mb={5}>
              <Typography variant="h3"  gutterBottom>
                What we do
              </Typography>
              
              <Typography variant="subtitle1">
                Discover the Fincal Business Solutions that we do.
              </Typography>
            </Box>
      <div className="container">
        {/* Feature Tabs */}
        <ul
  className="nav nav-tabs row d-flex justify-content-center text-center"
  data-aos="fade-up"
  data-aos-delay="100"
>
  {["Accounting", "Tax Services", "Business Advisory", "Audit & Assurance", "Tax Consultancy"].map((service, index) => {
    const tabId = `features-tab-${index + 1}`;
    return (
      <li className="nav-item col-12 col-md-2" key={tabId}>
        <a
          className={`nav-link ${activeTab === tabId ? "active show" : ""}`}
          onClick={() => handleTabClick(tabId)}
          style={{
            color: activeTab === tabId
              ? darkMode
                ? "#fff"
                : "#000"
              : darkMode
              ? "#bbb"
              : "#555",
          }}
        >
          <i className={`fas fa-${["calculator", "file-invoice-dollar", "briefcase", "search-dollar", "hand-holding-usd"][index]} fa-2x mb-2`}></i>
          <h4 style={{ fontSize: "0.9rem" }}>{service}</h4>
        </a>
      </li>
    );
  })}
</ul>

        {/* End Tab Nav */}

        {/* Tab Content */}
        <div className="tab-content mt-4" data-aos="fade-up" data-aos-delay="200">
          {/* Tab content mapping */}
          {[
            {
              id: "features-tab-1",
              title: "We provide a full suite of accounting services to keep your financial records accurate and up-to-date.",
              points: [
                "Bookkeeping and Financial Reporting",
                "Payroll Management",
                "Accounts Payable & Receivable",
                "Financial Statement Preparation",
                "Auditing & Assurance Services",
              ],
              img: "assets/img/dash.jpg",
            },
            {
              id: "features-tab-2",
              title: "At Fincal Business Solutions, we specialize in tax compliance and planning, minimizing your liabilities.",
              points: [
                "Tax Preparation and Filing (Individual and Business)",
                "Corporate Tax Compliance",
                "Tax Planning and Advisory",
                "VAT and Sales Tax Reporting",
                "Income Tax Audits",
              ],
              img: "assets/img/qwe.jpg",
            },
            {
              id: "features-tab-3",
              title: "Our business advisory services are designed to help you make sound financial decisions and grow sustainably.",
              points: [
                "Financial Planning and Analysis",
                "Budgeting and Forecasting",
                "Business Restructuring",
                "Cash Flow Management",
                "Risk Management",
              ],
              img: "assets/img/qw.jpg",
            },
            {
              id: "features-tab-4",
              title: "We provide reliable auditing services to ensure your business adheres to regulations and standards.",
              points: [
                "Internal Audits",
                "External Audits",
                "Risk Assessment",
                "Compliance Audits",
                "Tax Restructuring",
              ],
              img: "assets/img/tax.jpg",
            },
            {
              id: "features-tab-5",
              title: "Get expert guidance on complex tax matters, ensuring compliance and tax savings.",
              points: [
                "Tax Restructuring",
                "Tax Planning for Businesses",
                "Estate and Trust Tax Preparation",
                "Expatriate Tax Advisory",
                "M&A Tax Planning",
              ],
              img: "assets/img/wer.jpeg",
            },
          ].map((tab) => (
            <div className={`tab-pane fade ${activeTab === tab.id ? "active show" : ""}`} id={tab.id} key={tab.id}>
              <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                  <h6>{tab.title}</h6>
                  <ul className="list-unstyled" style={{ color: darkMode ? "#ddd" : "#000" }}>
                    {tab.points.map((point, index) => (
                      <li key={index}>
                        <i className="bi bi-check2-all text-primary"></i> {point}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                  <img
                    src={tab.img}
                    alt={tab.title}
                    className="img-fluid rounded shadow-sm"
                    style={{ filter: darkMode ? "brightness(0.8)" : "none" }} // Optional for images
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* End Tab Content */}

        {/* View All Services Button */}
        <Grid item xs={12} className="text-center mt-4">
          <Button variant="outlined" color="warning" size="large" href="/services">
            View All Services
          </Button>
        </Grid>
      </div>
    </section>
  );
};

export default ServicesSection;
